import clsx from "clsx";

export const FORECAST_GRID_CLASSES = {
  container: clsx("bg-white shadow-raro sm:rounded-lg"),
  header: clsx("px-4 py-5 sm:p-6 border-b border-raro-gray-200"),
  title: clsx(
    "text-lg font-medium leading-6 text-raro-gray-900 mb-4 font-montserrat"
  ),
  subtitle: clsx("text-sm text-raro-gray-500 mb-6", "font-montserrat"),
  grid: clsx("px-4 py-5 sm:p-6 space-y-6"),
  emptyState: clsx("px-4 py-8 sm:p-8"),
};
